<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ButtonIconType } from '@/enums/ButtonIconType.enum';
import { ButtonIconColor } from '@/enums/ButtonIconColor.enum';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'CButtonIcon',
	props: {
		iconName: {
			required: true,
			type: String,
		},
		type: {
			required: false,
			type: String as PropType<ButtonIconType>,
			default: () => ButtonIconType.RAISED,
			validator: (value: ButtonIconType) => Object.values(ButtonIconType).includes(value),
		},
		color: {
			required: false,
			type: String as PropType<ButtonIconColor>,
			default: () => ButtonIconColor.BASIC,
			validator: (value: ButtonIconColor) => Object.values(ButtonIconColor).includes(value),
		},
		isActive: {
			required: false,
			type: Boolean,
			default: false,
		},
	},
	computed: {
		activeClass(): string {
			return `c-button-icon-${this.color}--active`;
		},
	},
});
</script>

<template>
	<button
		v-wave
		:class="[
			'flex-center',
			'c-button-icon',
			`c-button-icon-${type}`,
			`c-button-icon-${color}`,
			{ [activeClass]: isActive },
		]"
	>
		<font-awesome-icon :icon="iconName" />
	</button>
</template>

<style scoped lang="scss">

.c-button-icon {
	@include tools.size(32px);

  border: 1px solid #0000002e;
	border-radius: 4px;
	font-size: 16px;
	cursor: pointer;

	&:hover {
		border-color: #C6C7C8;
    background: #D3D4D5;
	}
}

// colors
.c-button-icon-basic {
	background: tokens.$color-white;
	color: black;
}
.c-button-icon-basic--active {
	@extend .c-button-icon--active;
}

.c-button-icon-primary {
	background: tokens.$color-white;
	color: tokens.$color-blue;
}
.c-button-icon-primary--active {
	@extend .c-button-icon--active;
}

.c-button-icon-secondary {
	background: tokens.$color-gray-f1;
	color: tokens.$color-gray-89;
}
.c-button-icon-secondary--active {
	@extend .c-button-icon--active;

	background: tokens.$color-pastel-blue;
}

.c-button-icon--active {
	border-color: #BABBBC;
	background-color: #C6C7C8;
}

//types
.c-button-icon-raised {
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
}

.c-button-icon-flat {
	border: none;
	box-shadow: none;
}
</style>
